import React, { createContext, useState, useContext, useRef, useEffect } from 'react';
import HowlerPlayer from './howlerPlayer/Howlerplayer';

const AudioPlayerContext = createContext();

export const AudioPlayerProvider = ({ children }) => {
    const [currentAudio, setCurrentAudio] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [showPlayer, setShowPlayer] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const audioRef = useRef(null);

    const playAudio = (audioData) => {
        const wasPlaying = isPlaying;
        const isNewAudio = !currentAudio || currentAudio.id !== audioData.id;

        setIsLoading(true);
        setCurrentAudio(audioData);
        setShowPlayer(true);

        if (audioRef.current) {
            if (isNewAudio) {
                audioRef.current.src = audioData.song_url;
                audioRef.current.load();
            }

            const playPromise = audioRef.current.play();

            if (playPromise !== undefined) {
                playPromise.then(() => {
                    setIsPlaying(true);
                    setIsLoading(false);
                }).catch(error => {
                    console.error("Audio play failed:", error);
                    setIsPlaying(false);
                    setIsLoading(false);
                });
            } else {
                setIsPlaying(true);
                setIsLoading(false);
            }
        }
    };

    const closePlayer = () => {
        if (audioRef.current) {
            audioRef.current.pause();
        }
        setShowPlayer(false);
        setIsPlaying(false);
        setCurrentAudio(null);
        setIsLoading(false);
    };

    const handlePlayStateChange = (playing) => {
        setIsPlaying(playing);
        if (audioRef.current) {
            if (playing) {
                audioRef.current.play().catch(e => console.error("Error resuming play:", e));
            } else {
                audioRef.current.pause();
            }
        }
    };

    return (
        <AudioPlayerContext.Provider
            value={{
                currentAudio,
                isPlaying,
                isLoading,
                playAudio,
                closePlayer,
                setIsPlaying: handlePlayStateChange,
                audioRef,
            }}
        >
            {/* Centralized, hidden audio element */}
            <audio ref={audioRef} preload="metadata" style={{ display: 'none' }} />

            {children}

            {showPlayer && currentAudio && (
                <div className="fixed-player-container">
                    <HowlerPlayer
                        audio={currentAudio}
                        isPlaying={isPlaying}
                        setIsPlaying={handlePlayStateChange}
                        onClose={closePlayer}
                        isLoading={isLoading}
                    />
                </div>
            )}
        </AudioPlayerContext.Provider>
    );
};

export const useAudioPlayer = () => useContext(AudioPlayerContext);